// Autogenerated file
export const expensePeriodTypesEnum = {
    ByDate: "ByDate",
    ByMileage: "ByMileage",
};
export const expensePeriodTypes = [
    { label: "По дате", value: "ByDate" },
    { label: "По пробегу", value: "ByMileage" },
];
